import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "battery-3",
  "use": "battery-3-usage",
  "viewBox": "0 0 90 46.78",
  "content": "<symbol viewBox=\"0 0 90 46.78\" id=\"battery-3\"><title>资源 32</title><g id=\"battery-3_图层_2\" data-name=\"图层 2\"><g id=\"battery-3_图层_1-2\" data-name=\"图层 1\"><rect x=\"7.48\" y=\"7.48\" width=\"42.16\" height=\"31.81\" /><path d=\"M85.7,15.53V7.86A8.11,8.11,0,0,0,77.46,0H8.23A8.11,8.11,0,0,0,0,7.86V39.11a8.08,8.08,0,0,0,8.23,7.67H77.65a8.11,8.11,0,0,0,8.23-7.86V31.06A4,4,0,0,0,90,27.13V19.27A4.28,4.28,0,0,0,85.7,15.53Zm-4,3.93h0V38.92a4.08,4.08,0,0,1-4.21,3.93H8.23a4,4,0,0,1-4.12-3.93V7.86A4,4,0,0,1,8.23,3.93H77.65a3.92,3.92,0,0,1,4,3.93Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/battery-3.svg
// module id = lxX+
// module chunks = 264